import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL, HTTP_STATUS } from '../../utils/constant'
import { newAxiosInstance } from '../../../axios'

const initialState = {
    profiles: [],
    status: HTTP_STATUS.IDLE,
    deleteStatus: HTTP_STATUS.IDLE,
    profileSummary: null,
    profileSummaryStatus: HTTP_STATUS.IDLE,
}

export const fetchWorkforceProfiles = createAsyncThunk('workforceProfile/get-by-product', async (productId, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.get(`${BASE_URL}/api/WorkforceProfile/get-by-product/${productId}`)
        return response.data
    } catch (err) {
        if (!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const createWorkforceProfile = createAsyncThunk('workforceProfile/create', async (postdata, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.post(`${BASE_URL}/api/WorkforceProfile`, postdata)
        return response.data
    } catch (err) {
        if (!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const updateWorkforceProfile = createAsyncThunk('workforceProfile/update', async (postdata, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.put(`${BASE_URL}/api/WorkforceProfile/${postdata.id}`, postdata)
        return response.data
    } catch (err) {
        if (!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const deleteWorkforceProfile = createAsyncThunk('workforceProfile/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.delete(`${BASE_URL}/api/WorkforceProfile/${id}`)
        return response.data
    } catch (err) {
        if (!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const fetchProfileKpiSummary = createAsyncThunk('workforceProfile/kpi-summary', async (profileId, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.get(`${BASE_URL}/api/WorkforceProfile/${profileId}/kpi-summary`)
        return response.data
    } catch (err) {
        if (!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

const WorkforceProfileSlice = createSlice({
    name: 'workforceProfile',
    initialState,
    reducers: {
        resetState: (state) => initialState
    },
    extraReducers(builder) {
        builder
            .addCase(fetchWorkforceProfiles.pending, (state) => {
                state.status = HTTP_STATUS.LOADING
            })
            .addCase(fetchWorkforceProfiles.fulfilled, (state, action) => {
                state.status = HTTP_STATUS.SUCCEEDED
                state.profiles = action.payload
            })
            .addCase(fetchWorkforceProfiles.rejected, (state) => {
                state.status = HTTP_STATUS.FAILED
            })
            .addCase(deleteWorkforceProfile.pending, (state) => {
                state.deleteStatus = HTTP_STATUS.LOADING
            })
            .addCase(deleteWorkforceProfile.fulfilled, (state) => {
                state.deleteStatus = HTTP_STATUS.SUCCEEDED
            })
            .addCase(deleteWorkforceProfile.rejected, (state) => {
                state.deleteStatus = HTTP_STATUS.FAILED
            })
            .addCase(fetchProfileKpiSummary.pending, (state) => {
                state.profileSummaryStatus = HTTP_STATUS.LOADING
                state.profileSummary = null
            })
            .addCase(fetchProfileKpiSummary.fulfilled, (state, action) => {
                state.profileSummaryStatus = HTTP_STATUS.SUCCEEDED
                state.profileSummary = action.payload
            })
            .addCase(fetchProfileKpiSummary.rejected, (state) => {
                state.profileSummaryStatus = HTTP_STATUS.FAILED
            })
    }
})

export const getWorkforceProfiles = (state) => state.workforceProfile.profiles;
export const getWorkforceProfileStatus = (state) => state.workforceProfile.status;
export const getWorkforceProfileDeleteStatus = (state) => state.workforceProfile.deleteStatus;
export const getProfileSummary = (state) => state.workforceProfile.profileSummary;
export const getProfileSummaryStatus = (state) => state.workforceProfile.profileSummaryStatus;

export const workforceProfileActions = WorkforceProfileSlice.actions;

export default WorkforceProfileSlice.reducer;
